<script>
import appConfig from "@/app.config";
import PageList from "../../layouts/page-list";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'News',
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    PageList
  },
  data() {
    return {
      listFields: [
        {key: "type", sortable: true, label: this.$t('news.type')},
        {key: "title", sortable: true, label: this.$t('news.title')},
        {key: "subtitle", sortable: true, label: this.$t('news.subtitle')},
        {key: "body", sortable: true, label: this.$t('news.body')},
        {key: "created_at", sortable: true, label: this.$t('news.created_at')},
        {key: "updated_at", sortable: true, label: this.$t('news.updated_at')},
        {key: "published_at", sortable: true, label: this.$t('news.published_at')},
        {key: "publisher", sortable: true, label: this.$t('news.publisher')},
        {key: "state", sortable: true, label: this.$t('news.state')},
        {key: "tags", sortable: true, label: this.$t('news.tags')},
        {key: "actions", sortable: false, class: 'text-right', label: " ", tdAttr: {valign: "middle"}},
      ],
      listProviderFields: {
        with: 'publisher',
        all: true
      },
      updateListe: false
    }
  },
  methods: {
    displayDate(date) {
      const splitDate = date.replace('T', ' ').split("-");
      const splitTime = splitDate[2].split(' ');

      if (splitTime[1]) {
        return splitTime[0].split() + "/" + splitDate[1] + "/" + splitDate[0] + " " + splitTime[1].split('.')[0];

      }

      return splitTime[0].split() + "/" + splitDate[1] + "/" + splitDate[0];
    },

    getTypeClasses(type) {
      switch (type) {
        case 'external':
          return 'bg-info text-capitalize';
        case 'pdf':
          return 'bg-pdf text-uppercase';
        case 'video':
          return 'bg-success text-capitalize';
        case 'youtube':
          return 'bg-youtube text-capitalize';
        default:
          return 'bg-primary text-capitalize';
      }
    }
  }
};
</script>

<template>
  <page-list resource-name="new" :list-fields="listFields" :list-provider-fields="listProviderFields"
             :update-liste="updateListe" :with-advanced-search="true" @updated="updateListe = false">
    <template #cell(body)="data">
      <div v-if="!data.item.body && !data.item.file_id"></div>
      <a v-else-if="data.item.type === 'pdf'" :href="'/api/news/' + data.item.id + '/file'"
         target="_blank">
        Lien
      </a>
      <a v-else-if="data.item.type === 'youtube'" target="_blank" :href="'https://youtu.be/' + data.item.body">Lien</a>
      <a v-else-if="data.item.type !== 'article'" target="_blank" :href="data.item.body">Lien</a>
      <span v-else>{{ data.item.body }}</span>
    </template>

    <template #cell(type)="data">
      <span class="badge" :class="getTypeClasses(data.item.type)">
        {{ $t('news.types.' + data.item.type) }}
      </span>
    </template>

    <template #cell(publisher)="data">
      <span v-if="data.item.publisher">{{ data.item.publisher.last_name }} {{ data.item.publisher.first_name }}</span>
    </template>

    <template #cell(created_at)="data">
      <span v-if="data.item.created_at">{{ displayDate(data.item.created_at) }}</span>
    </template>

    <template #cell(updated_at)="data">
      <span v-if="data.item.updated_at">{{ displayDate(data.item.updated_at) }}</span>
    </template>

    <template #cell(published_at)="data">
      <span v-if="data.item.published_at">{{ displayDate(data.item.published_at) }}</span>
    </template>

    <template #cell(state)="data">
      <span class="text-capitalize">
        <span :class="data.item.state === 'validated' ? 'bg-success' : 'bg-warning'" class="badge">
          {{ $t('news.states.' + data.item.state) }}
        </span>
      </span>
    </template>

    <template #cell(tags)="data">
      <div v-if="data.item.tags">
        <span v-for="tag in data.item.tags" :key="tag.id" class="badge me-2"
              :style="{ backgroundColor: '#' + tag.color }">
          {{ tag.name }}
        </span>
      </div>
    </template>
  </page-list>
</template>